import { render, staticRenderFns } from "./account-management.vue?vue&type=template&id=784dc7a2&scoped=true&"
import script from "./account-management.vue?vue&type=script&lang=js&"
export * from "./account-management.vue?vue&type=script&lang=js&"
import style0 from "./account-management.vue?vue&type=style&index=0&id=784dc7a2&prod&lang=less&scoped=true&"
import style1 from "./account-management.vue?vue&type=style&index=1&id=784dc7a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784dc7a2",
  null
  
)

export default component.exports